export const blogData = [
    {
        id: 1,
        title: 'Context API Semantic Tag',
        description: 'Context provides a way to pass data through the component tree without having to pass props down manually at every level.',
        date: 'May 7, 2022',
        image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/context-api.png',
        url: 'https://product-analysis-website-cvf.netlify.app/blogs'
    },
    {
        id: 2,
        title: 'Javascript and Node JS',
        description: 'Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser.',
        date: 'May 11, 2022',
        image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/node.png',
        url: 'https://warehouse-management-8e867.web.app/blog'
    },
    {
        id: 3,
        title: 'React',
        description: 'React is a free and open-source front-end JavaScript library for building user interfaces based on UI components. It is maintained by Meta and a community of individual developers and companies.',
        date: 'May 14, 2022',
        image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/react2.jpg',
        url: 'https://bike-parts-cd343.web.app/blog'
    },
    {
        id: 4,
        title: 'Authorization and Authentication',
        description: 'Firebase is a platform developed by Google for creating mobile and web applications.',
        date: 'May 17, 2022',
        image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/firebase1.png',
        url: 'https://photography-services-e857d.web.app/blog'
    },

]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/